export const en = {
  pollingForm: {
    titles: {
      placeVote: 'Place Your Vote',
      voteResults: 'Vote Results',
      noCharitiesNominated: 'No Charities Nominated Yet',
    },
    descriptions: {
      hoverForDetails: 'Hover for details',
      checkBackSoon:
        'Check back soon to cast your vote and help direct funding to the community!',
      lastQuarterWinners: "Last quarter's winners:",
    },
    buttons: {
      voteForCharity: 'Vote for Charity',
    },
    pagination: {
      pageOf: 'Page {{current}} of {{total}}',
    },
    validation: {
      required: 'Required.',
    },
    alerts: {
      choiceSubmitted: 'Thanks for submitting your vote',
    },
  },
}
